module.exports = __webpack_public_path__ + "img/icon_tap_01.c5f9a6e1.svg";